if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.isDexcom = !!this.dataset.dexcom;
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // checking avilable in current location
      let totalUsed = 0;
      const variantId = parseInt(this.form.querySelector('[name=id]').value);
      let quantityToAdd = parseInt(document.querySelector('[name=quantity]').value);
      const location = JSON.parse(window.localStorage.getItem('location_city')) || 'Ontario';
      const cartData = await fetch('/cart.js').then(data => data.json());
      const variantInCart = cartData.items.find(item => item.id === variantId);
      const errorWrapper = this.form.querySelector('.product-form__error-message-wrapper');
      const locale = document.body.dataset.locale;

      // Per order limit
      const getOrderLimitBool = this.form.dataset.orderlimit;
      const getLimitPerOrder = this.form.dataset.limitperorder;

      const orderLimit = (typeof getOrderLimitBool !== "undefined" && getOrderLimitBool != "") ? getOrderLimitBool : false;
      const limitPerOrder = (typeof getLimitPerOrder !== "undefined" && getLimitPerOrder != "") ? getLimitPerOrder : 2;

      // console.log(limitPerOrder);

      if (variantInCart) {
      	totalUsed += variantInCart.quantity
      }


      // handle quantity selector error
      if (!quantityToAdd || quantityToAdd < 0) {
        const enErrString = `Please enter a valid quantity.`;
        const frErrString = `Veuillez entrer une quantité valide.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        errorWrapper.removeAttribute('hidden');
        return;
      }


     // const availableInLocation = await fetch(`https://mednow-inventory.herokuapp.com/?variant=${variantId}&location=${location}`).then(res => res.json());
     // const availableQty = availableInLocation.node.available;
      // const availableQty = $(this.form.querySelector('[name=id]')).data('available');

      // limit order quantity for a specific product
      if(orderLimit && (quantityToAdd + totalUsed) > limitPerOrder) {
        errorWrapper.removeAttribute('hidden');
        const enErrString = `The limit for this product is ${limitPerOrder} units per order.`;
        const frErrString = `La limite pour ce produit est de ${limitPerOrder} unités par commande.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }

  /*    if (quantityToAdd > (availableQty - totalUsed)) {
        errorWrapper.removeAttribute('hidden');
        console.log(availableQty)
        if (availableQty > 0) {
        	const enErrString = `Only ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'items are' : 'item is'} available at your location.`;
            const frErrString = `Seuls ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'articles' : 'article'} sont disponibles chez vous.`;
            errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        } else {
        	const enErrString = `No items available at your location.`;
            const frErrString = `Aucun article disponible à votre emplacement.`;
            errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        }

        if (totalUsed > 0) {
          const enErrString = `Only ${availableQty} ${availableQty > 1 ? 'items are' : 'item is'} available at your location and ${totalUsed} ${totalUsed > 1 ? 'items are' : 'item is'} already in your cart!`;
          const frErrString = `Seulement ${availableQty} ${availableQty > 1 ? 'articles' : 'article'} sont disponibles chez vous et ${totalUsed} ${totalUsed > 1 ? 'articles' : 'article'} sont déjà dans votre panier !`;
          errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
        }

        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        return;
      }
*/

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if(this.isDexcom) window.location.href = "/cart";
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:addedpdp'));
          document.querySelector('#cart-icon-bubble').dispatchEvent(new Event('click'));
          console.log(response)
          this.cartNotification.renderContents(response);


        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.querySelector("cart-drawer").updateTax();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
